/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForIdentityOntologySyncAdhoc extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForIdentityOntologySyncAdhoc");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForIdentityOntologySyncAdhoc.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForIdentityOntologySyncAdhoc>): BackgroundJobPayloadForIdentityOntologySyncAdhoc {
        let obj = Object.assign(new BackgroundJobPayloadForIdentityOntologySyncAdhoc(), model);
        BackgroundJobPayloadForIdentityOntologySyncAdhoc.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForIdentityOntologySyncAdhoc>): BackgroundJobPayloadForIdentityOntologySyncAdhoc {
        if (!model) return null;
        return BackgroundJobPayloadForIdentityOntologySyncAdhoc.newInstance(<BackgroundJobPayloadForIdentityOntologySyncAdhoc> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForIdentityOntologySyncAdhoc) {
        if (!obj) return;

        models.BackgroundJobPayloadForIdentityOntologySyncAdhoc.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForIdentityOntologySyncAdhoc): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForIdentityOntologySyncAdhoc.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
